import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { ICandidate, amplitude } from 'wisestep-api';
import { ICandidateAggregatedData } from 'wisestep-base';

import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

import CandidateSmsLogsUI from './CandidateSmsLogsUI';

interface ICandidateSmsLogs {
  candidate: ICandidate | null;
  aggregation?: ICandidateAggregatedData;
  amplitudeEventHandler?: (eventName: string) => void;
}

const CandidateSmsLogs = ({
  candidate,
  aggregation,
  amplitudeEventHandler = () => {},
}: ICandidateSmsLogs) => {
  const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);
  const smsLogsContactNumber = useConversationWidgetStore((state) => state.smsLogsContactNumber);

  useEffect(() => {
    if (aggregation && isEmpty(smsLogsContactNumber)) {
      if (aggregation?.candidateEntity?.phoneNumber) {
        if (candidate && candidate.phoneNumber) {
          setPhoneNumbers([
            candidate.phoneNumber,
            ...[aggregation.candidateEntity.phoneNumber],
            ...aggregation.candidateEntity.alternatePhoneNumbers,
          ]);
        } else {
          setPhoneNumbers([
            aggregation.candidateEntity.phoneNumber,
            ...aggregation.candidateEntity.alternatePhoneNumbers,
          ]);
        }
      }
    } else if (candidate && isEmpty(smsLogsContactNumber)) {
      if (candidate && candidate.phoneNumber) {
        setPhoneNumbers([candidate.phoneNumber, ...candidate.alternatePhoneNumbers]);
      }
    }
    if (!isEmpty(smsLogsContactNumber) && smsLogsContactNumber) {
      setPhoneNumbers([smsLogsContactNumber]);
    }
    amplitude('CandidateView_Communication_SMSLogs', {
      clickedOn: 'Communication Logs SMS',
      pageName: 'candidate-layout',
      pageUrl: window.location.href,
    });
    amplitudeEventHandler('Communication Logs SMS');
  }, [aggregation, candidate, candidate?.phoneNumber, smsLogsContactNumber]);

  return (
    <CandidateSmsLogsUI phoneNumbers={phoneNumbers} candidateId={candidate?.candidateId ?? ''} />
  );
};

export default CandidateSmsLogs;
